export default __webpack_public_path__ + "static/media/logo.4ef52f97.svg";